module.exports = __webpack_public_path__ + "img/add-storage.668cf43f.svg";